import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import AppNav from "./AppNav";
import ExperienceNav from "./ExperienceNav";
import PageNav from "./PageNav";
import ThemeNav from "./ThemeNav";
import MobileControls from "./MobileControls";

import * as appConfigActions from "../../actions/appConfigActions";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as experiencesActions from "../../actions/experiencesActions";
import * as globalActions from "../../actions/globalActions";
import * as pagesActions from "../../actions/pagesActions";
import * as responsiveActions from "../../actions/responsiveActions";
import Logo from "../../assets/img/verris-badge.png";

class Nav extends React.Component {
	componentDidMount() {
		const {
			appConfigActions,
			match: {
				params: { appKey },
			},
		} = this.props;
		appConfigActions.loadAppConfig(appKey);
	}

	render() {
		const {
			auth,
			match: {
				params: { appKey, expId, pageId, themeId },
			},
			responsive: { isResponsive, displaySideMenu },
			user,
		} = this.props;

		const appPage = appKey ? " app-page" : "";
		const expPage = expId ? " exp-page" : "";
		const pagePage = pageId ? " page-page" : "";
		const themePage = themeId ? " theme-page" : "";
		const responsiveSideMenu = isResponsive && displaySideMenu ? " show" : "";

		const leftMenuClass = `main-sidebar${appPage}${expPage}${pagePage}${themePage}${responsiveSideMenu}`;

		return (
			<div>
				{auth.user && user && (
					<aside id="leftmenu" className={leftMenuClass}>
						<div className="sidebar-logo">
							<img src={Logo} alt="logo" />
						</div>
						<div className={`sidebar-pages${displaySideMenu ? " show" : ""}`}>
							<div className="sidebar-pages-slider">
								{appKey && (
									<div className="sidebar-page">
										<AppNav {...this.props} user={user} />
									</div>
								)}
								{appKey && expId && (
									<div className="sidebar-page">
										<ExperienceNav {...this.props} user={user} />
									</div>
								)}
								{appKey && expId && pageId && (
									<div className="sidebar-page">
										<PageNav {...this.props} />
									</div>
								)}
								{appKey && themeId && (
									<div className="sidebar-page">
										<ThemeNav {...this.props} />
									</div>
								)}
							</div>
						</div>
						{displaySideMenu && <MobileControls {...this.props} />}
					</aside>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	appConfig: state.appConfig,
	auth: state.auth,
	experiences: state.experiences,
	pages: state.pages,
	responsive: state.responsive,
	themes: state.themes,
	user: state.user.user,
});

const mapDispatchToProps = dispatch => ({
	appConfigActions: bindActionCreators(appConfigActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	experiencesActions: bindActionCreators(experiencesActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	pagesActions: bindActionCreators(pagesActions, dispatch),
	responsiveActions: bindActionCreators(responsiveActions, dispatch),
});

Nav.propTypes = {
	auth: PropTypes.object,
	experiencesActions: PropTypes.object,
	match: PropTypes.object,
	pagesActions: PropTypes.object,
	responsiveActions: PropTypes.object,
	user: PropTypes.object,
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Nav)
);
